(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart-drawer-new-3"] && !Shopify.designMode) return;
  try {
    
(function () {
  // 防止 JS 被重复执行时多次注册监听器
  if (window.__bogoSelectModalInit) return;
  window.__bogoSelectModalInit = true;

  var bogoAddQueue = [];
  var bogoQueueRunning = false;
  var bogoLastAddAt = 0;
  var bogoRefreshTimer = null;
  var bogoCartNeedsRefresh = false;
  var BOGO_ADD_GAP = 3000;
  var BOGO_REFRESH_DELAY = 4000;
  var BOGO_RATE_LIMIT_WAIT = 4000;

  // 带重试的 fetch，应对第三方插件打满 API 速率限制导致的 429
  function fetchWithRetry(url, opts, retriesLeft) {
    retriesLeft = retriesLeft === undefined ? 4 : retriesLeft;
    return fetch(url, opts).then(function (r) {
      if (r.status === 429 && retriesLeft > 0) {
        return new Promise(function (resolve) {
          setTimeout(function () {
            resolve(fetchWithRetry(url, opts, retriesLeft - 1));
          }, 2000 * (5 - retriesLeft));
        });
      }
      return r;
    });
  }

  function addBogoVariantToCart(variantId) {
    return fetchWithRetry('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: parseInt(variantId, 10), quantity: 1 })
    }).then(function (r) {
      if (r.status === 429) return 'rate_limited';
      if (!r.ok) throw new Error('add failed');
      return r.json();
    });
  }

  function runBogoAddQueue() {
    if (bogoQueueRunning || !bogoAddQueue.length) return;
    bogoQueueRunning = true;

    var gapWait = Math.max(0, BOGO_ADD_GAP - (Date.now() - bogoLastAddAt));
    setTimeout(function () {
      var job = bogoAddQueue.shift();
      if (!job) {
        bogoQueueRunning = false;
        return;
      }

      var btn = job.btn;
      var origText = job.origText;
      btn.textContent = '...';

      addBogoVariantToCart(job.variantId)
        .then(function (result) {
          if (result === 'rate_limited') {
            bogoAddQueue.unshift(job);
            btn.textContent = 'Wait...';
            return false;
          }
          updateBogoProgressByCount(getCurrentBogoCount() + 1);
          bogoCartNeedsRefresh = true;
          btn.textContent = '✓ ADDED';
          delete btn.dataset.bogoQueued;
          setTimeout(function () {
            btn.textContent = origText;
            btn.disabled = false;
          }, 2000);
          return true;
        })
        .catch(function () {
          btn.textContent = origText;
          btn.disabled = false;
          delete btn.dataset.bogoQueued;
        })
        .finally(function () {
          bogoLastAddAt = Date.now();
          bogoQueueRunning = false;
          var nextDelay = btn.textContent === 'Wait...' ? BOGO_RATE_LIMIT_WAIT : 0;
          setTimeout(function () {
            runBogoAddQueue();
            tryRefreshCartWhenIdle();
          }, nextDelay);
        });
    }, gapWait);
  }

  // 等队列全部处理完再刷新购物车，避免每件商品加购都触发 refresh 和插件抢 API
  function tryRefreshCartWhenIdle() {
    if (!bogoCartNeedsRefresh || bogoQueueRunning || bogoAddQueue.length > 0) return;
    if (bogoRefreshTimer) clearTimeout(bogoRefreshTimer);
    bogoRefreshTimer = setTimeout(function () {
      bogoRefreshTimer = null;
      bogoCartNeedsRefresh = false;
      document.dispatchEvent(new CustomEvent('cart:refresh'));
    }, BOGO_REFRESH_DELAY);
  }

  function getChosenOptions(form) {
    var result = [];
    var maxPos = 0;
    form.querySelectorAll('select[name^="option"]').forEach(function (el) {
      var pos = parseInt(el.name.replace('option', ''), 10);
      if (pos > maxPos) maxPos = pos;
    });
    for (var i = 1; i <= maxPos; i++) {
      var el = form.querySelector('[name="option' + i + '"]');
      result.push(el ? el.value : null);
    }
    return result;
  }

  var bogoMoneyFormatter = null;

  function formatBogoMoney(cents) {
    if (typeof Shopify !== 'undefined') {
      if (!bogoMoneyFormatter) {
        bogoMoneyFormatter = new Intl.NumberFormat(Shopify.locale || 'en-US', {
          style: 'currency',
          currency: Shopify.currency.active
        });
      }
      return bogoMoneyFormatter.format(cents / 100);
    }
    return '$' + (cents / 100).toFixed(2);
  }

  function bogoVariantImageUrl(src) {
    if (!src) return '';
    var url = src.indexOf('//') === 0 ? 'https:' + src : src;
    if (url.indexOf('cdn.shopify.com') !== -1) {
      url = url.split('?')[0] + '?width=200';
    }
    return url;
  }

  function getMediaPreviewSrc(media) {
    if (!media || !media.preview_image) return '';
    return media.preview_image.src || media.preview_image.url || '';
  }

  function getBogoVariantImageSrc(variant) {
    if (!variant) return '';
    var fromMedia = getMediaPreviewSrc(variant.featured_media);
    if (fromMedia) return fromMedia;
    if (variant.featured_image && variant.featured_image.src) return variant.featured_image.src;
    return '';
  }

  function getBogoColorMediaSrc(form) {
    var colorSel = form.querySelector('.bogo-color-sel');
    if (!colorSel) return '';
    var opt = colorSel.options[colorSel.selectedIndex];
    if (!opt || !opt.dataset.variantMedia) return '';
    try {
      return getMediaPreviewSrc(JSON.parse(opt.dataset.variantMedia));
    } catch (e) {
      return '';
    }
  }

  function setBogoProductImage(img, rawSrc, defaultSrc) {
    var nextSrc = rawSrc ? bogoVariantImageUrl(rawSrc) : (defaultSrc || img.dataset.defaultSrc || img.getAttribute('src'));
    if (!nextSrc) return;
    var currentPath = img.src.split('?')[0];
    var nextPath = (nextSrc.indexOf('//') === 0 ? 'https:' + nextSrc : nextSrc).split('?')[0];
    if (currentPath === nextPath) return;
    img.removeAttribute('srcset');
    img.removeAttribute('sizes');
    img.src = nextSrc;
  }

  function updateBogoProductDisplay(form, match) {
    var productEl = form.closest('.bogo-modal-product');
    if (!productEl) return;

    var img = productEl.querySelector('.bogo-modal-product__img');
    if (img) {
      var rawSrc = getBogoVariantImageSrc(match) || getBogoColorMediaSrc(form);
      setBogoProductImage(img, rawSrc, img.dataset.defaultSrc);
    }

    var priceCurrent = productEl.querySelector('.bogo-modal-product__price-current');
    var priceCompare = productEl.querySelector('.bogo-modal-product__price-compare');
    if (!match || !priceCurrent) return;

    priceCurrent.textContent = formatBogoMoney(match.price);
    if (priceCompare) {
      if (match.compare_at_price && match.compare_at_price > match.price) {
        priceCompare.textContent = formatBogoMoney(match.compare_at_price);
        priceCompare.hidden = false;
      } else {
        priceCompare.hidden = true;
      }
    }
  }

  function updateVariant(form) {
    var variantsEl = form.querySelector('.bogo-variants-json');
    if (!variantsEl) return;
    var variants = JSON.parse(variantsEl.textContent);
    var chosen = getChosenOptions(form);
    var match = null;
    for (var i = 0; i < variants.length; i++) {
      var v = variants[i];
      if (v.options.length === chosen.length && v.options.every(function (opt, idx) { return opt === chosen[idx]; })) {
        match = v;
        break;
      }
    }
    var idInput = form.querySelector('.bogo-variant-id');
    var btn = form.querySelector('.bogo-modal-product__btn');
    if (match) {
      idInput.value = match.id;
      btn.disabled = !match.available;
    } else {
      btn.disabled = true;
    }
    updateBogoProductDisplay(form, match);
  }

  function initBogoProductForms() {
    document.querySelectorAll('#bogo-select-modal .bogo-product-form').forEach(function (form) {
      updateVariant(form);
    });
  }

  function updateColorDot(select) {
    var wrap = select.closest('.bogo-color-select-wrap');
    if (!wrap) return;
    var dot = wrap.querySelector('.bogo-color-dot');
    if (!dot) return;
    var opt = select.options[select.selectedIndex];
    if (!opt) return;
    var swatchStyle = opt.dataset.swatchStyle;
    if (swatchStyle) {
      dot.setAttribute('style', swatchStyle);
    }
  }

  function initColorDots() {
    document.querySelectorAll('.bogo-color-sel').forEach(function (sel) {
      updateColorDot(sel);
    });
  }

  initColorDots();

  document.addEventListener('dialog:after-show', function (e) {
    if (e.target && e.target.id === 'bogo-select-modal') {
      initColorDots();
      initBogoProductForms();
    }
  });

  document.addEventListener('change', function (e) {
    var target = e.target;
    if (target.classList.contains('bogo-color-sel')) {
      updateColorDot(target);
    }
    if (target.classList.contains('bogo-option-select') || target.classList.contains('bogo-color-sel')) {
      var form = target.closest('.bogo-product-form');
      if (form) updateVariant(form);
    }
  });

  function getCurrentBogoCount() {
    var modal = document.getElementById('bogo-select-modal');
    if (!modal) return 0;
    var fill = modal.querySelector('[data-bogo-progress-fill]');
    if (!fill) return 0;
    var pct = parseInt(fill.style.width, 10) || 0;
    return pct >= 100 ? 2 : pct >= 50 ? 1 : 0;
  }

  function updateBogoProgressByCount(count) {
    var modal = document.getElementById('bogo-select-modal');
    if (!modal) return;
    count = Math.min(Math.max(count, 0), 2);
    var pct = count === 0 ? 0 : count === 1 ? 50 : 100;
    var msg = modal.querySelector('[data-bogo-progress-msg]');
    var fill = modal.querySelector('[data-bogo-progress-fill]');
    var gift = modal.querySelector('[data-bogo-progress-gift]');
    if (msg) {
      msg.innerHTML = count >= 2
        ? 'BOGO Unlocked! Cheaper item is <strong>FREE</strong>.'
        : 'Unlock BOGO, Add 1 more!';
    }
    if (fill) fill.style.width = pct + '%';
    if (gift) {
      gift.src = count >= 2 ? modal.dataset.giftAnim : modal.dataset.giftStatic;
    }
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.bogo-modal-product__btn');
    if (!btn || btn.disabled || btn.dataset.bogoQueued === '1') return;
    var form = btn.closest('.bogo-product-form');
    if (!form) return;
    var variantId = form.querySelector('.bogo-variant-id').value;
    if (!variantId) return;

    btn.disabled = true;
    btn.dataset.bogoQueued = '1';
    var origText = btn.textContent.trim();
    btn.textContent = bogoQueueRunning || bogoAddQueue.length ? 'Queued' : '...';

    bogoAddQueue.push({ btn: btn, origText: origText, variantId: variantId });
    runBogoAddQueue();
  });

  function updateBogoProgress(items) {
    var modal = document.getElementById('bogo-select-modal');
    if (!modal) return;
    var bogoIdsStr = (modal.dataset.bogoIds || '').replace(/\s/g, '');
    var bogoIds = {};
    bogoIdsStr.split(',').forEach(function (id) { if (id) bogoIds[id] = true; });
    var count = 0;
    items.forEach(function (item) {
      if (bogoIds[String(item.product_id)]) count += item.quantity;
    });
    count = Math.min(count, 2);
    var pct = count === 0 ? 0 : count === 1 ? 50 : 100;
    var msg = modal.querySelector('[data-bogo-progress-msg]');
    var fill = modal.querySelector('[data-bogo-progress-fill]');
    var gift = modal.querySelector('[data-bogo-progress-gift]');
    if (msg) {
      msg.innerHTML = count >= 2
        ? 'BOGO Unlocked! Cheaper item is <strong>FREE</strong>.'
        : 'Unlock BOGO, Add 1 more!';
    }
    if (fill) fill.style.width = pct + '%';
    if (gift) {
      gift.src = count >= 2 ? modal.dataset.giftAnim : modal.dataset.giftStatic;
    }
  }

  document.addEventListener('cart:change', function (e) {
    if (e.detail && e.detail.cart && e.detail.cart.items) {
      updateBogoProgress(e.detail.cart.items);
    }
  });

  try {
    var stored = JSON.parse(localStorage.getItem('theme:cart-items') || '[]');
    if (stored.length) updateBogoProgress(stored);
  } catch (err) {}
})();

(function () {
  if (window.__buy3GiftModalInit) return;
  window.__buy3GiftModalInit = true;

  var buy3AddQueue = [];
  var buy3QueueRunning = false;
  var buy3LastAddAt = 0;
  var buy3RefreshTimer = null;
  var buy3CartNeedsRefresh = false;
  var BUY3_ADD_GAP = 3000;
  var BUY3_REFRESH_DELAY = 4000;
  var BUY3_RATE_LIMIT_WAIT = 4000;
  var BUY3_PROMO = {
    type: 'buy3_gift',
    campaign: 'buy3_get1'
  };

  function fetchWithRetry(url, opts, retriesLeft) {
    retriesLeft = retriesLeft === undefined ? 4 : retriesLeft;
    return fetch(url, opts).then(function (r) {
      if (r.status === 429 && retriesLeft > 0) {
        return new Promise(function (resolve) {
          setTimeout(function () {
            resolve(fetchWithRetry(url, opts, retriesLeft - 1));
          }, 2000 * (5 - retriesLeft));
        });
      }
      return r;
    });
  }

  function addBuy3GiftToCart(variantId) {
    return fetchWithRetry('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({
        id: parseInt(variantId, 10),
        quantity: 1,
        properties: {
          '_promo_type': BUY3_PROMO.type,
          '_promo_campaign': BUY3_PROMO.campaign
        }
      })
    }).then(function (r) {
      if (r.status === 429) return 'rate_limited';
      if (!r.ok) throw new Error('add failed');
      return r.json();
    });
  }

  function tryRefreshCartWhenIdle() {
    if (!buy3CartNeedsRefresh || buy3QueueRunning || buy3AddQueue.length > 0) return;
    if (buy3RefreshTimer) clearTimeout(buy3RefreshTimer);
    buy3RefreshTimer = setTimeout(function () {
      buy3RefreshTimer = null;
      buy3CartNeedsRefresh = false;
      document.dispatchEvent(new CustomEvent('cart:refresh'));
    }, BUY3_REFRESH_DELAY);
  }

  function runBuy3AddQueue() {
    if (buy3QueueRunning || !buy3AddQueue.length) return;
    buy3QueueRunning = true;

    var gapWait = Math.max(0, BUY3_ADD_GAP - (Date.now() - buy3LastAddAt));
    setTimeout(function () {
      var job = buy3AddQueue.shift();
      if (!job) {
        buy3QueueRunning = false;
        return;
      }

      var btn = job.btn;
      var origText = job.origText;
      btn.textContent = '...';

      addBuy3GiftToCart(job.variantId)
        .then(function (result) {
          if (result === 'rate_limited') {
            buy3AddQueue.unshift(job);
            btn.textContent = 'Wait...';
            return false;
          }
          buy3CartNeedsRefresh = true;
          btn.textContent = '✓ ADDED';
          delete btn.dataset.buy3Queued;

          var modal = document.getElementById('buy3-gift-select-modal');
          if (modal && typeof modal.hide === 'function') {
            modal.hide();
          }

          setTimeout(function () {
            btn.textContent = origText;
            btn.disabled = false;
          }, 2000);
          return true;
        })
        .catch(function () {
          btn.textContent = origText;
          btn.disabled = false;
          delete btn.dataset.buy3Queued;
        })
        .finally(function () {
          buy3LastAddAt = Date.now();
          buy3QueueRunning = false;
          var nextDelay = btn.textContent === 'Wait...' ? BUY3_RATE_LIMIT_WAIT : 0;
          setTimeout(function () {
            runBuy3AddQueue();
            tryRefreshCartWhenIdle();
          }, nextDelay);
        });
    }, gapWait);
  }

  function getChosenOptions(form) {
    var result = [];
    var maxPos = 0;
    form.querySelectorAll('select[name^="option"]').forEach(function (el) {
      var pos = parseInt(el.name.replace('option', ''), 10);
      if (pos > maxPos) maxPos = pos;
    });
    for (var i = 1; i <= maxPos; i++) {
      var el = form.querySelector('[name="option' + i + '"]');
      result.push(el ? el.value : null);
    }
    return result;
  }

  var buy3MoneyFormatter = null;

  function formatBuy3Money(cents) {
    if (typeof Shopify !== 'undefined') {
      if (!buy3MoneyFormatter) {
        buy3MoneyFormatter = new Intl.NumberFormat(Shopify.locale || 'en-US', {
          style: 'currency',
          currency: Shopify.currency.active
        });
      }
      return buy3MoneyFormatter.format(cents / 100);
    }
    return '$' + (cents / 100).toFixed(2);
  }

  function buy3VariantImageUrl(src) {
    if (!src) return '';
    var url = src.indexOf('//') === 0 ? 'https:' + src : src;
    if (url.indexOf('cdn.shopify.com') !== -1) {
      url = url.split('?')[0] + '?width=200';
    }
    return url;
  }

  function getMediaPreviewSrc(media) {
    if (!media || !media.preview_image) return '';
    return media.preview_image.src || media.preview_image.url || '';
  }

  function getBuy3VariantImageSrc(variant) {
    if (!variant) return '';
    var fromMedia = getMediaPreviewSrc(variant.featured_media);
    if (fromMedia) return fromMedia;
    if (variant.featured_image && variant.featured_image.src) return variant.featured_image.src;
    return '';
  }

  function getBuy3ColorMediaSrc(form) {
    var colorSel = form.querySelector('.buy3-gift-color-sel');
    if (!colorSel) return '';
    var opt = colorSel.options[colorSel.selectedIndex];
    if (!opt || !opt.dataset.variantMedia) return '';
    try {
      return getMediaPreviewSrc(JSON.parse(opt.dataset.variantMedia));
    } catch (e) {
      return '';
    }
  }

  function setBuy3ProductImage(img, rawSrc, defaultSrc) {
    var nextSrc = rawSrc ? buy3VariantImageUrl(rawSrc) : (defaultSrc || img.dataset.defaultSrc || img.getAttribute('src'));
    if (!nextSrc) return;
    var currentPath = img.src.split('?')[0];
    var nextPath = (nextSrc.indexOf('//') === 0 ? 'https:' + nextSrc : nextSrc).split('?')[0];
    if (currentPath === nextPath) return;
    img.removeAttribute('srcset');
    img.removeAttribute('sizes');
    img.src = nextSrc;
  }

  function updateBuy3ProductDisplay(form, match) {
    var productEl = form.closest('.buy3-gift-modal-product');
    if (!productEl) return;

    var img = productEl.querySelector('.buy3-gift-modal-product__img');
    if (img) {
      var rawSrc = getBuy3VariantImageSrc(match) || getBuy3ColorMediaSrc(form);
      setBuy3ProductImage(img, rawSrc, img.dataset.defaultSrc);
    }

    var priceCurrent = productEl.querySelector('.buy3-gift-modal-product__price-current');
    var priceCompare = productEl.querySelector('.buy3-gift-modal-product__price-compare');
    if (!match || !priceCurrent) return;

    priceCurrent.textContent = formatBuy3Money(match.price);
    if (priceCompare) {
      if (match.compare_at_price && match.compare_at_price > match.price) {
        priceCompare.textContent = formatBuy3Money(match.compare_at_price);
        priceCompare.hidden = false;
      } else {
        priceCompare.hidden = true;
      }
    }
  }

  function updateBuy3Availability(form, isAvailable) {
    var btn = form.querySelector('.buy3-gift-modal-product__btn');
    var notice = form.querySelector('.buy3-gift-modal-product__sold-out-notice');
    if (!btn || btn.dataset.buy3Queued === '1') return;

    btn.disabled = !isAvailable;
    if (notice) {
      notice.hidden = !!isAvailable;
    }
  }

  function updateBuy3Variant(form) {
    var variantsEl = form.querySelector('.buy3-gift-variants-json');
    if (!variantsEl) return;
    var variants = JSON.parse(variantsEl.textContent);
    var chosen = getChosenOptions(form);
    var match = null;
    for (var i = 0; i < variants.length; i++) {
      var v = variants[i];
      if (v.options.length === chosen.length && v.options.every(function (opt, idx) { return opt === chosen[idx]; })) {
        match = v;
        break;
      }
    }
    var idInput = form.querySelector('.buy3-gift-variant-id');
    if (match) {
      idInput.value = match.id;
      updateBuy3Availability(form, !!match.available);
    } else {
      if (idInput) idInput.value = '';
      updateBuy3Availability(form, false);
    }
    updateBuy3ProductDisplay(form, match);
  }

  function initBuy3ProductForms() {
    document.querySelectorAll('#buy3-gift-select-modal .buy3-gift-product-form').forEach(function (form) {
      updateBuy3Variant(form);
    });
  }

  function updateBuy3ColorDot(select) {
    var wrap = select.closest('.buy3-gift-color-select-wrap');
    if (!wrap) return;
    var dot = wrap.querySelector('.buy3-gift-color-dot');
    if (!dot) return;
    var opt = select.options[select.selectedIndex];
    if (!opt) return;
    var swatchStyle = opt.dataset.swatchStyle;
    if (swatchStyle) {
      dot.setAttribute('style', swatchStyle);
    }
  }

  function initBuy3ColorDots() {
    document.querySelectorAll('.buy3-gift-color-sel').forEach(function (sel) {
      updateBuy3ColorDot(sel);
    });
  }

  initBuy3ColorDots();

  document.addEventListener('dialog:after-show', function (e) {
    if (e.target && e.target.id === 'buy3-gift-select-modal') {
      initBuy3ColorDots();
      initBuy3ProductForms();
    }
  });

  document.addEventListener('change', function (e) {
    var target = e.target;
    if (target.classList.contains('buy3-gift-color-sel')) {
      updateBuy3ColorDot(target);
    }
    if (target.classList.contains('buy3-gift-option-select') || target.classList.contains('buy3-gift-color-sel')) {
      var form = target.closest('.buy3-gift-product-form');
      if (form) updateBuy3Variant(form);
    }
  });

  document.addEventListener('click', function (e) {
    var chooseBtn = e.target.closest('.buy3-gift-modal-product__btn');
    if (chooseBtn && !chooseBtn.disabled && chooseBtn.dataset.buy3Queued !== '1') {
      var form = chooseBtn.closest('.buy3-gift-product-form');
      if (!form) return;
      var variantId = form.querySelector('.buy3-gift-variant-id').value;
      if (!variantId) return;

      chooseBtn.disabled = true;
      chooseBtn.dataset.buy3Queued = '1';
      var origText = chooseBtn.textContent.trim();
      chooseBtn.textContent = buy3QueueRunning || buy3AddQueue.length ? 'Queued' : '...';

      buy3AddQueue.push({ btn: chooseBtn, origText: origText, variantId: variantId });
      runBuy3AddQueue();
    }
  });
}());

  } catch(e) { console.error(e); }
})();
})();
